import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressReferences = () => {
    const setReferences = useWordPressStore((state) => state.setReferences);

    return useMutation(WordpressApi.getReferences, {
        onSuccess: (data) => {
            setReferences(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};